export default {
      id: "maintenance_notifications-usage",
      viewBox: "0 0 34 30",
      url: __webpack_public_path__ + "img/icons.svg#maintenance_notifications",
      toString: function () {
        return this.url;
      }
    }